import BaseListener from "./baseListener";
import { TrackEvent } from "./baseListener";

class InputStayListener extends BaseListener {
  private observer: any = null;
  private timers: Map<HTMLInputElement | HTMLTextAreaElement, number> = new Map();

  constructor() {
    super();
    this.createObserver();
  }

  private createObserver() {
    this.observer = new MutationObserver((mutations:any) => {
      mutations.forEach((mutation: any) => {
        // 只处理当前容器内的变化
        if (!mutation.target.isConnected) return;
        (mutation.target as HTMLElement).querySelectorAll('input,textarea,.winitd-upload').forEach((el: Element) => {
          const htmlEl = el as HTMLInputElement | HTMLTextAreaElement;
          if (!htmlEl.dataset?.trackerBound) {
            htmlEl.dataset.trackerBound = 'true';
            htmlEl.addEventListener('focus', () => this.handleFocus(htmlEl));
            htmlEl.addEventListener('blur', () => this.handleBlur(htmlEl));
          }
        });
      });
    });
  }

  private handleFocus = (el: HTMLInputElement | HTMLTextAreaElement) => {
    this.timers.set(el, Date.now());
  };
  private handleBlur = (el: HTMLInputElement | HTMLTextAreaElement) => {
    const startTime = this.timers.get(el);
    if (startTime) {
      const endTime = Date.now();
      const duration = endTime - startTime;
      if(duration < 100){return;} //停留时间太短不记录
      let nodeName = el.nodeName;
      let uploadVal: any = '';
      let selectedVal: any = '';
      let radioGroupId: any = '';
      let checkboxId: any = '';
      let checkboxLabel: any = '';
      let checkboxVal = '';
      if (el.classList.contains('winitd-select-selection-search-input')) {
        nodeName = 'SELECT';
        selectedVal = el.closest('.winitd-select-selector')?.querySelector('.winitd-select-selection-item')?.getAttribute?.('title')?.trim();
      }
      else if (el.classList.contains('winitd-checkbox-input')) {
        nodeName = 'CHECKBOX';
        let checkboxParent = el?.closest('.winitd-checkbox');
        checkboxVal = checkboxParent?.classList?.contains('winitd-checkbox-checked') ? 'Y' : 'N';//@TODO如果异步后再勾选的，取值就不准确了
        checkboxLabel = (checkboxParent?.nextSibling as HTMLElement)?.innerText?.trim();
        checkboxId = el.getAttribute?.('value');
      }
      else if (el.classList.contains('winitd-radio-input')) {
        nodeName = 'RADIO';
        radioGroupId = el.closest('.winitd-radio-group')?.getAttribute?.('id');
      }
      else if (el.classList.contains('winitd-upload')) {
        nodeName = 'UPLOAD';
        uploadVal = el?.closest('.winitd-upload-list')?.querySelector('.winitd-upload-list-item-name')?.getAttribute?.('title')?.trim();
      }
      const placeholder = el.getAttribute?.('placeholder');
      const dataFieldLabel = el.getAttribute?.('data-monitor-fieldLabel');
      const dataFieldkey = el.getAttribute?.('data-monitor-fieldKey');
      const formItem = el.closest('.winitd-form-item');
      const labelElement = formItem?.querySelector<HTMLElement>('.winitd-form-item-label label');
      const labelFor = labelElement?.getAttribute('for');
      let fieldLabel = labelElement?.innerText?.trim();
      if (!fieldLabel) {
        fieldLabel = formItem?.closest('.winitd-row')?.querySelector<HTMLElement>('.winitd-form-item-label label')?.innerText?.trim();
      }
      //表格布局的控件
      let thLabel = '';
      if (!fieldLabel && el?.closest('td')) {
        let tdIndex = el?.closest('td')?.cellIndex;
        let theadTr = el?.closest('table')?.querySelector('thead tr:last-child');
        if (tdIndex !== undefined && theadTr) {
          thLabel = theadTr.querySelectorAll('th')[tdIndex]?.innerText?.trim();
        }
      }
      let ext:any = {
        blurTimestamp: endTime
      };
      this.config.onEmit({
        nodeType: 'inputStay',
        nodeName: nodeName,
        fieldKey: dataFieldkey || el.id || labelFor || radioGroupId || checkboxId || '',
        fieldLabel: dataFieldLabel || checkboxLabel || fieldLabel || thLabel || placeholder || '',
        fieldVal:  selectedVal || checkboxVal || uploadVal || el.value,
        duration,
        timestamp: startTime,
        ext,
      },el);
      this.timers.delete(el);
    }
  };

  start(onEmit: (event: TrackEvent,el?: HTMLElement) => void,container: HTMLElement) {
    this.config = {
      onEmit: onEmit,
      container: container,
    };
    this.observer.observe(this.config.container, {
      childList: true,
      subtree: true
    });
  };


  stop() {
    this.config.container.querySelectorAll('[data-tracker-bound="true"]').forEach((el:any) => {
      el.removeEventListener('focus', () => this.handleFocus(el));
      el.removeEventListener('blur', () => this.handleBlur(el));
    });
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

export default InputStayListener;
